/**
 * Hotels info with filtering
 */

// TODO: PY05649-832. COMENTADO PARA EVITAR ERROR CON GMAPZ. SE HARÁ UNA NUEVA MEJORA PARA IMPLEMENTAR EL NUEVO HOTELSINFO.
// import '../../shared/hotels_map_for_filter_mice_page/hotels_map_for_filter_mice_page'
import '../../shared/cards/card_init_swiper'
import '../../shared/cards/show_discounts'
import './hotels_info_with_filtering_mice_meetings'
import './dependencies/booking_results'
import './dependencies/hotel_card_slider_mobile_gallery'

/* eslint-disable */
import { currentDevice } from '../../core/utils/currentDevice'
import { init as initCards } from '../../shared/cards/cards_behavior'
import { initFilterOrderPanel } from '../../shared/filter_order_panel/filter_order_panel'
import { initDiscountTooltips } from '../../shared/tooltip_for_discounts/tooltip_for_discounts'
import { updatePricesInfo } from '../../shared/update_prices/update_prices'
import { readCookie } from '../../utils/cookie_manager'
import { copyToClipboardNew } from '../../utils/copy_to_clipboard'
import { getHotelIDsFromHotelCodes } from '../../utils/hotels_data_bridge'
import getRealMarketContent, { dispatchRealMarketContentUpdatedEvent } from '../../utils/real_market_wrapper'

//TODO: 73371 -> Comentado porque en la página de destinos ya no hay filtros y se ha eliminado todo el JS
// import {
//   destroy as destroyDestinationsIndex,
//   init as initDestinationsIndex,
// } from '../destinations_index_packed/destinations_index'
import { clearFilters, destroyEvents as destroyFiltersEvents, init as initFilters } from './dependencies/filters'
import { HOTEL_LIST_UPDATED_EVENT } from './dependencies/list_events'
import { init as initHighlights } from './dependencies/offer_highlight/offer_highlight'
import { init as initOrdering } from './dependencies/order_results'
import { destroyEvents as destroyPaginationEvents, init as initPagination } from './dependencies/pagination/pagination'
import { PaginationManager } from './dependencies/pagination/pagination_manager'
import { initializeUtagEvents } from './hotels_info_with_filtering_mice.analytics'
import { FILTERS_IN_PARAMS } from './hotels_info_with_filtering_mice.constants'

function initializeBlock(blockSelector, blockName) {
  const block = document.querySelector(blockSelector)

  if (!block) return

  initCards(blockSelector)

  let initialHotelIDs = block.dataset && block.dataset.allHotels
  const htmlDataset = document.getElementsByTagName('html')[0].dataset
  const Manager = new PaginationManager(blockName, htmlDataset, initialHotelIDs)
  initPagination(Manager)
  initOrdering(Manager)
  initFilters(Manager)
  initCodeCopyButton()

  localStorage.removeItem('filter_hotel_ids')
  createDestHeaderMobile() // will execute only if MQBE is mobile
  initDeps()
  checkTabToShow()
  managePaginationVisibility()
  IB.hotel_card_slider_mobile_gallery.init()

  initializeUtagEvents(blockSelector)
}

export function init(blockId, blockName, callback) {
  const blockSelector = `[data-block-id="${blockId}"]`
  const block = document.querySelector(blockSelector)

  if (!block) return

  initializeBlock(blockSelector, blockName)

  // Reinitialize hotel cards when html is replaced
  document.addEventListener(HOTEL_LIST_UPDATED_EVENT, () => {
    initCards(blockSelector)
  })

  if(callback) callback()

  const mainContainer = block.closest('.js-block-layer')

  if (!mainContainer) return

  // Replace all the html content with the real market html content
  // destroy all previous initializations and reinitialize the block
  const constrainedViewId = block.dataset.constrainedViewId

  const urlParams = new URLSearchParams(window.location.search)

  // Add filter params to URL so getRealMarketContent can use them
  const additionalParams = Array.from(urlParams.entries())
    .filter(([key]) => FILTERS_IN_PARAMS.includes(key))
    .map(([key, value]) => `${key}=${value}`)
    .join('&')
  getRealMarketContent({ blockId, constrainedViewId, additionalParams })
    .then(response => {
      destroyDestinationsIndex()
      destroyFiltersEvents()
      destroyPaginationEvents()

      mainContainer.outerHTML = response.html_replacement

      const $block = $(blockSelector)

      initDestinationsIndex()
      initializeBlock(blockSelector, blockName)
      IB.lazyImg.addImgToObserver($block)

      // Reinit prices after replacement
      updatePricesInfo()
      IB.currencyForm.forceUpdate($block)

      if(callback) callback()

      const eventBlockName = blockName === 'automatic_offer_list' ? 'automatic-offer-list' : 'hotel-list'
      dispatchRealMarketContentUpdatedEvent({ blockSelector, blockName: eventBlockName })
    })
    .catch(error => {
      // console.warn(error);
    })
}

/**
 * Initialize dependencies.
 */
function initDeps() {
  if (currentDevice.isMobile || currentDevice.isLikeMobile) {
    initFilterOrderPanel()
    $('[data-mobile-panel]').mobilepanel()
    IB.hotels_filter_map.startHotelsMapMobile()
  }

  $('.hotels-info-with-filtering').find('input[type=checkbox], input[type=radio], select').formikation()
  IB.currencyForm.forceUpdate()
  updatePricesInfo()
  initDiscountTooltips()
  $('.hotel-list [data-tooltip]').each(function (index, element) {
    IB.tooltip.init($(element))
  })
  IB.opinionsWidgets.init()

  initHighlights()
}

/**
 * The so called Adverts were originally placed between cards in the listing.
 * The pagination feature in the listing removed this placement.
 * Moved to bottom of the listing, TO DO: create advert in the back and
 * recheck at the end of the feature development.
 */
function manageBanners() {
  let $banners = $('.card-banner')
  let $banner_parent = $($banners[0]).parent()
  let banner_positions = $banners.map(function (index, $value) {
    return $banner_parent.find('> *').index($($value))
  })

  $banners.map(function (index, $value) {
    $banner_parent.find('> *:nth-child(' + banner_positions[index] + ')').after($value)
  })
}

/**
 * Default active tab is "List" but we might auto activate
 * the map tab if the show-map-tab is present if we are not
 * in mobile.
 */
function checkTabToShow() {
  if (!currentDevice.isMobile || !currentDevice.isLikeMobile) {
    let show_map_tab = $('.wrapper.hotels-info-with-filtering').data('show-map-tab')
    if (show_map_tab === 1) {
      $('.tabs-menu > li a.hotel-map-link').click()
      $('#hotels-filter-map').css('display', 'block')
      $('.filtering-container .pagination').css('display', 'none')
      $('.filtering-container .offer-dates-legend').css('display', 'none')
    }
  }
}

/**
 * Clones desktop destination-index-header, changes IDs to prevent
 * duplicates and sets aria-selected to false as no tab is selected upfront.
 */
function createDestHeaderMobile() {
  if ((currentDevice.isMobile || currentDevice.isLikeMobile)) {
    let $clone_destination_header = $('.destination-index-header').first().clone(true, true)
    let $mobile_sticky_container = $('.mobile-sticky-container')
    if ($mobile_sticky_container.length) {
      $clone_destination_header.find('[role="tab"]').each(function () {
        // replace ids with -sticky string to avoid duplicated id's
        if ($(this).attr('id')) {
          $(this).attr('id', $(this).attr('id') + '-sticky')
        }
        // on mobile, we don't have any tab selected at first, so we set all aria-selected to false
        if ($(this).attr('aria-selected')) {
          $(this).attr('aria-selected', false)
        }
      })
      $clone_destination_header.addClass('js-mobile-destination-index-header')
      $mobile_sticky_container.append($clone_destination_header)
    }
  }
}


function managePaginationVisibility() {
  let $links = $('.actions.tabs-menu li a')

  $links.each(function () {
    $(this).click(function (event) {
      event.preventDefault()
      if ($(this).hasClass('hotel-list-link')) {
        $('.filtering-container .pagination').css('display', 'block')
        $('.filtering-container .offer-dates-legend').css('display', 'block')
      } else {
        $('.filtering-container .pagination').css('display', 'none')
        $('.filtering-container .offer-dates-legend').css('display', 'none')
      }
    })
  })
}

export function simulateOfferInputCheckWithClick(offerId) {
  const isChecked = document.querySelector(`.js-filter-block [data-offer-id="${offerId}"] > input:checked`)
  if (isChecked) return

  clearFilters(null, false)

  document.querySelector(`.js-filter-block [data-offer-id="${offerId}"]`).click()
}

export function openOfferBlockInHotelsInfoFilters() {
  const offersFilterBlockTitle = document.querySelector('.js-filters-sidebar [data-filter-type="offer-filters"] .js-filter-title:not(.active)')
  const buttonApplyFilterMobile = document.querySelector('.js-apply-filters')

  if (currentDevice.isMobile || currentDevice.isLikeMobile) {
    setTimeout(() => {
      buttonApplyFilterMobile?.click()
    }, 1000);
  } else {
    offersFilterBlockTitle?.click()
  }
}

function initCodeCopyButton() {
  // Copy promo code
  const codeCopyButtons = document.querySelectorAll('.offer-highlight .js-copy-to-clipboard')
  if (codeCopyButtons.length){
    codeCopyButtons.forEach(button => {
      button.addEventListener('click', function (event) {
        const content = event.target
        const promocode = content.dataset.promocode
        const textCopiedTraslation = content.dataset.translations
        copyToClipboardNew(promocode).then(() => {
          content.innerText = textCopiedTraslation
          content.classList.remove('show-icon')
          setTimeout(() => {
            content.innerText = promocode
            content.classList.add('show-icon')
          }, 3000)
        })
      })
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initCards('.js-hotels-info-with-filtering-mice')
})
